import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import {
  Facebook,
  GoHighLevel,
  Google,
  LinkedIn,
  Mailchimp,
  MetaBrand,
  Shopify,
  TikTokBrand,
  TwitterBrand,
  Wix,
  YouTubeBrand,
} from 'blaze-ui/icons/20'
import { absurd } from 'types'
import { Fragment } from 'react'
import { IconProps } from 'blaze-ui/icons/Types'
import { WordPressBrand } from 'blaze-ui/icons/35'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { ZapierLogo } from 'almanac-ui/icons/24'

interface Props extends IconProps {
  provider: ExternalIntegrationEnum
}

export const getProviderIcon = (provider: ExternalIntegrationEnum) => {
  switch (provider) {
    case ExternalIntegrationEnum.Facebook:
      return Facebook
    case ExternalIntegrationEnum.Instagram:
      return InstagramBrand
    case ExternalIntegrationEnum.LinkedIn:
      return LinkedIn
    case ExternalIntegrationEnum.X:
      return TwitterBrand
    case ExternalIntegrationEnum.TikTok:
      return TikTokBrand
    case ExternalIntegrationEnum.GoHighLevel:
      return GoHighLevel
    case ExternalIntegrationEnum.Google:
      return Google
    case ExternalIntegrationEnum.Mailchimp:
      return Mailchimp
    case ExternalIntegrationEnum.MetaAds:
      return MetaBrand
    case ExternalIntegrationEnum.GoogleAds:
      return Google
    case ExternalIntegrationEnum.Shopify:
      return Shopify
    case ExternalIntegrationEnum.WordPress:
      return WordPressBrand
    case ExternalIntegrationEnum.YouTube:
      return YouTubeBrand
    case ExternalIntegrationEnum.GoogleDrive:
      return Google
    case ExternalIntegrationEnum.Wix:
      return Wix
    case ExternalIntegrationEnum.GoogleBusinessProfile:
      return Google
    case ExternalIntegrationEnum.GoogleCalendar:
    case ExternalIntegrationEnum.MicrosoftGraph:
      return Google
    case ExternalIntegrationEnum.Zapier:
      return ZapierLogo
    default:
      absurd(provider)
      return null
  }
}

export const ProviderIcon = ({ provider, ...props }: Props) => {
  const Icon = getProviderIcon(provider)
  return Icon ? <Icon {...props} /> : <Fragment />
}
